export default function IsDarkColor(color) {
	// Convert color to RGB format
	if (color.charAt(0) === "#") {
		color = color.slice(1);
	}
	const r = Number.parseInt(color.slice(0, 2), 16);
	const g = Number.parseInt(color.slice(2, 4), 16);
	const b = Number.parseInt(color.slice(4, 6), 16);

	// Calculate luminance using the relative luminance formula
	const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

	// Determine if the color is dark or light based on luminance
	if (luminance > 128) {
		return false;
	}
	return true;
}
